<template>
  <div class="example">{{ msg }}</div>
</template>

<script>
export default {
  data() {
    return {
      msg: 'Hello world! i came from Vue component',
    };
  },
};
</script>

<style lang="scss">
.example {
  margin: 1em auto;
  padding: 1em;
  border: 1px solid fuchsia;

  color: red;
}
</style>
